import CardPropertyObjectTable from '../../components/Card/CardPropertyObjectTable.vue'

function getProviderOrganizationURLFn () {
  return function (object) {
    const urlParams = new URLSearchParams()
    if (object.id != null && object.id != -1) {
      urlParams.set('objectId', object.id)
    }
    urlParams.set('actual', true)

    return '/service/delta/vehicleGroupType/getAvailableProviders?' + urlParams.toString()
  }
}

export function getCustomTabsList (config) {
  const { create, createConfig, access, subtypeKey, objectData } = config

  // const isFence = subtypeKey === 'fenceCategory'

  const notApproved = create || !objectData.object.approved
  const applicantEditAccess = notApproved && access.applicantAccess
  const descriptionPropsEditAccess = applicantEditAccess || access.approvalAccess
  // const usagePropsEditAccess = access.approvalAccess

  return [
    {
      key: 'params',
      name: 'Основное',
      props: [
        {
          key: 'approved',
          name: 'Утвержден',
          _visible: !create && !objectData.object.approved || access.fullAccess,
          _editable: access.approvalAccess,
          componentProps: {
            class: function (value, object) {
              if (value) {
                return 'd-field--shadow-green'
              } else {
                return 'd-field--shadow-yellow'
              }
            }
          }
        },
        { key: '$key', name: 'Код', _visible: !create && access.fullAccess, _editable: false },
        { key: 'vehicleGroupCategory', name: 'Категория', _editable: descriptionPropsEditAccess },
        { key: 'numberInCategory', name: 'Номер в категории', _editable: descriptionPropsEditAccess },
        { key: 'descr', name: 'Описание', _editable: descriptionPropsEditAccess },
        { key: 'vehiclesCount', name: 'Число ТС', _editable: descriptionPropsEditAccess },
        { key: 'actual', name: 'Актуальный', _editable: descriptionPropsEditAccess && !(createConfig && createConfig.actualReadonly) },
        { key: 'provided', name: 'Предоставляемый', _visible: access.fullAccess, _editable: false },
        { key: 'providableToBrigade', name: 'Предоставляемый бригаде', _visible: access.fullAccess, _editable: false },
        {
          key: 'vehicleGroupTypeProviderOrganization',
          name: 'Организации - поставщики',
          type: 'objects',
          _editable: descriptionPropsEditAccess,
          component: CardPropertyObjectTable,
          componentProps: {
            getURL: getProviderOrganizationURLFn(),
            dialogLabel: 'Выбор контракта',
            showRelationship: false,
            hideHeader: false,
            copy: true
          }
        }
      ]
    }
  ]
}
